import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToolTipPopper } from 'components';

class TextArea extends Component {
  render() {
    const { labelText, required, placeholder, error, disabled, id, name, helptext, toolTipDetails, title } = this.props;

    let inputView = (
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        className={classnames(
          'lf-input',
          'lf-textarea',
          `${this.props.classNames}`,
          { [`lf-input--disabled`]: disabled },
          { [`lf-input--error`]: error },
          { [`lf-textarea-title`]: title }
        )}
        onChange={this.props.onChange}
        required={required ? true : false}
        disabled={disabled}
        onBlur={this.props.onBlur}
        defaultValue={this.props.initialValue}
      />
    );

    return (
      <div className="lf-input-wrap">
        <div style={{ display: 'flex' }}>
          <label htmlFor={id} className={`lf-input__label ${required ? 'required' : ''}`}>
            {labelText}
          </label>
          {toolTipDetails ? <ToolTipPopper placement="top-start" trigger="click" tooltip={toolTipDetails} /> : ''}
        </div>
        {inputView}
        <span className="lf-input__helptext">{helptext}</span>
        {error && <p className="lf-input__helper">{error}</p>}
      </div>
    );
  }
}

TextArea.propTypes = {
  labelText: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.any,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  helptext: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  initialValue: PropTypes.any,
  onInputFieldChange: PropTypes.func,
  passwordToggle: PropTypes.bool,
  classNames: PropTypes.string,
  toolTipDetails: PropTypes.object,
  title: PropTypes.object,
};

export default TextArea;
